(function(){
  function initCategories(){
    var root=document.querySelector('[data-category-filter]');
    var cards=Array.prototype.slice.call(document.querySelectorAll('[data-product-card]'));
    if(!root || !cards.length) return;
    var buttons=Array.prototype.slice.call(root.querySelectorAll('[data-filter-handle]'));
    function apply(handle){
      buttons.forEach(function(b){
        var active=b.getAttribute('data-filter-handle')===handle;
        b.classList.toggle('is-active',active);
        b.setAttribute('aria-pressed',active?'true':'false');
      });
      cards.forEach(function(card){
        var list=(card.getAttribute('data-collections')||'').split(',').filter(Boolean);
        card.hidden=(handle!=='all' && list.indexOf(handle)===-1);
      });
    }
    buttons.forEach(function(button){
      button.setAttribute('aria-pressed',button.classList.contains('is-active')?'true':'false');
      button.addEventListener('click',function(){apply(button.getAttribute('data-filter-handle')||'all');});
    });
    apply('all');
  }

  function initProductGallery(){
    var gallery=document.querySelector('[data-product-gallery]');
    if(!gallery) return;
    var images=Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-image]'));
    var thumbs=Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prev=gallery.querySelector('[data-gallery-prev]');
    var next=gallery.querySelector('[data-gallery-next]');
    var zoom=gallery.querySelector('[data-gallery-zoom]');
    var fullscreen=document.querySelector('[data-gallery-fullscreen]');
    var fullscreenImage=fullscreen ? fullscreen.querySelector('[data-gallery-fullscreen-image]') : null;
    var fullscreenClose=fullscreen ? fullscreen.querySelector('[data-gallery-fullscreen-close]') : null;
    var fullscreenPrev=fullscreen ? fullscreen.querySelector('[data-gallery-fullscreen-prev]') : null;
    var fullscreenNext=fullscreen ? fullscreen.querySelector('[data-gallery-fullscreen-next]') : null;
    var fullscreenZoomIn=fullscreen ? fullscreen.querySelector('[data-fullscreen-zoom-in]') : null;
    var fullscreenZoomOut=fullscreen ? fullscreen.querySelector('[data-fullscreen-zoom-out]') : null;
    if(images.length < 1) return;
    var current=0;
    var fullscreenScale=1;
    var pinchStartDistance=null;
    var pinchStartScale=1;
    var imageOffsetX=0;
    var imageOffsetY=0;
    var panStartX=null;
    var panStartY=null;
    var panStartOffsetX=0;
    var panStartOffsetY=0;
    var panMoved=false;
    var suppressFullscreenSwipe=false;
    function applyFullscreenZoom(nextScale){
      fullscreenScale=Math.max(1,Math.min(8,nextScale));
      if(fullscreenScale===1){imageOffsetX=0;imageOffsetY=0;}
      if(fullscreenImage){
        fullscreenImage.style.transform='translate('+imageOffsetX+'px,'+imageOffsetY+'px) scale('+fullscreenScale+')';
        fullscreenImage.style.cursor=fullscreenScale>1?'grab':'zoom-in';
      }
      if(fullscreen){fullscreen.classList.toggle('is-zoomed',fullscreenScale>1);}
    }

    function resetZoom(){
      images.forEach(function(img){ img.classList.remove('is-zoomed'); });
      if(zoom){ zoom.setAttribute('aria-pressed','false'); zoom.textContent='＋'; }
    }

    function show(index, direction){
      var previous=current;
      current=(index+images.length)%images.length;
      resetZoom();
      images.forEach(function(img,i){
        img.classList.remove('is-active','is-slide-left','is-hidden');
        if(i===current){
          img.classList.add('is-active');
        } else if(i===previous && direction==='next'){
          img.classList.add('is-slide-left');
        }
      });
      thumbs.forEach(function(thumb,i){
        thumb.classList.toggle('is-active',i===current);
        thumb.setAttribute('aria-current',i===current?'true':'false');
      });
    }

    function openFullscreen(){
      if(!fullscreen || !fullscreenImage) return;
      fullscreenImage.src=images[current].getAttribute('src');
      fullscreenImage.alt=images[current].getAttribute('alt')||'Product image';
      imageOffsetX=0;imageOffsetY=0;panMoved=false;suppressFullscreenSwipe=false;
      applyFullscreenZoom(1);
      fullscreen.classList.add('is-open');
      fullscreen.setAttribute('aria-hidden','false');
      document.body.style.overflow='hidden';
    }
    function closeFullscreen(){
      if(!fullscreen) return;
      fullscreen.classList.remove('is-open');
      fullscreen.setAttribute('aria-hidden','true');
      document.body.style.overflow='';
    }
    images.forEach(function(img){
      img.addEventListener('click',function(e){
        e.preventDefault();
        openFullscreen();
      });
    });
    if(fullscreenClose) fullscreenClose.addEventListener('click',closeFullscreen);
    if(fullscreenZoomIn) fullscreenZoomIn.addEventListener('click',function(e){e.stopPropagation();applyFullscreenZoom(fullscreenScale+0.5);});
    if(fullscreenZoomOut) fullscreenZoomOut.addEventListener('click',function(e){e.stopPropagation();applyFullscreenZoom(fullscreenScale-0.5);});
    if(fullscreenImage){
      fullscreenImage.addEventListener('click',function(e){
        e.stopPropagation();
        if(panMoved){panMoved=false;return;}
        applyFullscreenZoom(fullscreenScale>=8?1:fullscreenScale+1);
      });
      fullscreenImage.addEventListener('dblclick',function(e){e.preventDefault();e.stopPropagation();applyFullscreenZoom(fullscreenScale>1?1:3);});
      fullscreenImage.addEventListener('wheel',function(e){e.preventDefault();applyFullscreenZoom(fullscreenScale+(e.deltaY<0?0.35:-0.35));},{passive:false});
      fullscreenImage.addEventListener('touchstart',function(e){
        if(fullscreenScale>1 && e.touches && e.touches.length===1){
          panStartX=e.touches[0].clientX;panStartY=e.touches[0].clientY;
          panStartOffsetX=imageOffsetX;panStartOffsetY=imageOffsetY;panMoved=false;
        } else {panStartX=null;panStartY=null;}
      },{passive:true});
      fullscreenImage.addEventListener('touchmove',function(e){
        if(fullscreenScale<=1 || panStartX===null || !e.touches || e.touches.length!==1) return;
        var dx=e.touches[0].clientX-panStartX;var dy=e.touches[0].clientY-panStartY;
        if(Math.abs(dx)>3 || Math.abs(dy)>3){panMoved=true;suppressFullscreenSwipe=true;}
        imageOffsetX=panStartOffsetX+dx;imageOffsetY=panStartOffsetY+dy;
        applyFullscreenZoom(fullscreenScale);
        if(e.cancelable)e.preventDefault();
      },{passive:false});
      fullscreenImage.addEventListener('touchend',function(){
        if(panMoved)suppressFullscreenSwipe=true;
        panStartX=null;panStartY=null;
      },{passive:true});
    }
    if(fullscreenPrev) fullscreenPrev.addEventListener('click',function(){show(current-1,'prev'); openFullscreen();});
    if(fullscreenNext) fullscreenNext.addEventListener('click',function(){show(current+1,'next'); openFullscreen();});
    if(fullscreen) fullscreen.addEventListener('click',function(e){
      if(e.target===fullscreen) closeFullscreen();
    });
    document.addEventListener('keydown',function(e){
      if(!fullscreen || !fullscreen.classList.contains('is-open')) return;
      if(e.key==='Escape') closeFullscreen();
      if(e.key==='ArrowLeft'){show(current-1,'prev'); openFullscreen();}
      if(e.key==='ArrowRight'){show(current+1,'next'); openFullscreen();}
    });

    var fullscreenStartX=null;
    if(fullscreen){
      fullscreen.addEventListener('touchstart',function(e){
        if(e.touches && e.touches.length===2){
          var dx=e.touches[0].clientX-e.touches[1].clientX;var dy=e.touches[0].clientY-e.touches[1].clientY;
          pinchStartDistance=Math.sqrt(dx*dx+dy*dy);pinchStartScale=fullscreenScale;fullscreenStartX=null;
        } else if(e.touches && e.touches[0]) fullscreenStartX=e.touches[0].clientX;
      },{passive:true});
      fullscreen.addEventListener('touchmove',function(e){
        if(e.touches && e.touches.length===2 && pinchStartDistance){
          var dx=e.touches[0].clientX-e.touches[1].clientX;var dy=e.touches[0].clientY-e.touches[1].clientY;
          applyFullscreenZoom(pinchStartScale*(Math.sqrt(dx*dx+dy*dy)/pinchStartDistance));
        }
      },{passive:true});
      fullscreen.addEventListener('touchend',function(e){
        if(pinchStartDistance!==null){pinchStartDistance=null;return;}
        if(suppressFullscreenSwipe){suppressFullscreenSwipe=false;fullscreenStartX=null;return;}
        if(fullscreenScale>1){fullscreenStartX=null;return;}
        if(fullscreenStartX===null || !e.changedTouches || !e.changedTouches[0]) return;
        var delta=e.changedTouches[0].clientX-fullscreenStartX;
        if(Math.abs(delta)>45){ show(delta<0?current+1:current-1,delta<0?'next':'prev'); openFullscreen(); }
        fullscreenStartX=null;
      },{passive:true});
    }

    thumbs.forEach(function(thumb){
      thumb.addEventListener('click',function(){
        show(parseInt(thumb.getAttribute('data-gallery-thumb'),10)||0);
      });
    });
    if(prev) prev.addEventListener('click',function(){show(current-1,'prev');});
    if(next) next.addEventListener('click',function(){show(current+1,'next');});
    if(zoom) zoom.addEventListener('click',function(){
      var img=images[current];
      var on=!img.classList.contains('is-zoomed');
      img.classList.toggle('is-zoomed',on);
      zoom.setAttribute('aria-pressed',on?'true':'false');
      zoom.textContent=on?'−':'＋';
    });
    images.forEach(function(img){
      img.addEventListener('dblclick',function(){
        if(!zoom) return;
        var on=!img.classList.contains('is-zoomed');
        img.classList.toggle('is-zoomed',on);
        zoom.setAttribute('aria-pressed',on?'true':'false');
        zoom.textContent=on?'−':'＋';
      });
    });

    var startX=null;
    gallery.addEventListener('touchstart',function(e){
      if(e.touches && e.touches[0]) startX=e.touches[0].clientX;
    },{passive:true});
    gallery.addEventListener('touchend',function(e){
      if(startX===null || !e.changedTouches || !e.changedTouches[0]) return;
      var delta=e.changedTouches[0].clientX-startX;
      if(Math.abs(delta)>45) show(delta<0?current+1:current-1,delta<0?'next':'prev');
      startX=null;
    },{passive:true});

    show(0);
    var galleryTimer=null;
    function startGalleryAuto(){
      if(images.length<2) return;
      if(galleryTimer) clearInterval(galleryTimer);
      galleryTimer=setInterval(function(){
        if(fullscreen && fullscreen.classList.contains('is-open')) return;
        show(current+1,'next');
      },3500);
    }
    startGalleryAuto();
  }

  function initOutOfStockButtons(){
    var buttons=Array.prototype.slice.call(document.querySelectorAll('[data-out-of-stock]'));
    if(!buttons.length) return;
    var toast=null;
    buttons.forEach(function(button){
      button.addEventListener('click',function(){
        if(!toast){
          toast=document.createElement('div');
          toast.className='out-of-stock-toast';
          toast.setAttribute('role','status');
          toast.textContent='Not Available — Soon Arrived Inshallah';
          document.body.appendChild(toast);
        }
        toast.textContent='Not Available — Soon Arrived Inshallah';
        toast.classList.add('is-visible');
        if(toast._hideTimer) window.clearTimeout(toast._hideTimer);
        toast._hideTimer=window.setTimeout(function(){toast.classList.remove('is-visible');},1800);
      });
    });
  }


  function initAdnanCartSelection(){
    var floating = document.querySelector('[data-adnan-floating-cart]');
    var countNode = document.querySelector('[data-adnan-cart-count]');
    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-adnan-add-to-cart]'));
    var busy = false;
    var cachedCart = null;

    function getCart(){
      return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){if(!r.ok)throw new Error('Cart could not be loaded');return r.json();});
    }
    function renderCart(cart){
      cachedCart = cart;
      if(countNode) countNode.textContent = cart.item_count || 0;
      if(floating) floating.hidden = !(cart.item_count > 0);
      buttons.forEach(function(btn){
        var id = String(btn.getAttribute('data-variant-id'));
        var line = (cart.items || []).find(function(item){return String(item.variant_id)===id;});
        btn.classList.toggle('is-selected', !!line);
        btn.setAttribute('aria-pressed', line ? 'true' : 'false');
        var label = btn.querySelector('.cart-label');
        if(label) label.textContent = line ? 'ADDED' : 'CART';
        var plus = btn.querySelector('.cart-plus');
        if(plus) plus.textContent = line ? '✓' : '＋';
        btn.title = line ? 'Click to remove from cart' : 'Add to Cart';
      });
    }
    function refresh(){return getCart().then(renderCart).catch(function(){});}
    buttons.forEach(function(btn){
      btn.setAttribute('aria-pressed','false');
      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        if(busy) return;
        busy = true;
        var variantId = String(btn.getAttribute('data-variant-id'));
        var label = btn.querySelector('.cart-label');
        var plus = btn.querySelector('.cart-plus');
        var wasSelected = btn.classList.contains('is-selected');
        btn.disabled = true;
        btn.classList.add('is-loading');
        if(!wasSelected){
          btn.classList.add('is-selected');
          if(label) label.textContent = 'ADDING';
          if(plus) plus.textContent = '✓';
        }
        var cartReady = cachedCart ? Promise.resolve(cachedCart) : getCart();
        cartReady.then(function(cart){
          cachedCart = cart;
          var line = (cart.items || []).find(function(item){return String(item.variant_id)===variantId;});
          if(line){
            return fetch('/cart/change.js', {
              method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
              body:JSON.stringify({id:line.key, quantity:0})
            }).then(function(r){if(!r.ok)throw new Error('Could not remove item');return r.json();});
          }
          return fetch('/cart/add.js', {
            method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
          }).then(function(r){if(!r.ok)throw new Error('Could not add item');return r.json();}).then(function(){return getCart();});
        }).then(renderCart).catch(function(){
          btn.classList.remove('is-selected');
          if(label) label.textContent = 'RETRY';
          if(plus) plus.textContent = '＋';
          return refresh();
        }).finally(function(){
          busy=false; btn.disabled=false; btn.classList.remove('is-loading');
        });
      });
    });
    refresh();
    window.addEventListener('pageshow', refresh);

    var clearButton = document.querySelector('[data-adnan-clear-cart]');
    if(clearButton){
      clearButton.addEventListener('click', function(){
        if(busy) return;
        var sure = window.confirm('Clear all selected items from your cart?');
        if(!sure) return;
        busy = true; clearButton.disabled = true;
        fetch('/cart/clear.js', {method:'POST',headers:{'Accept':'application/json'}}).then(function(r){
          if(!r.ok) throw new Error('Could not clear cart'); return r.json();
        }).then(renderCart).catch(function(){refresh();}).finally(function(){busy=false;clearButton.disabled=false;});
      });
    }
  }

  /* Store and product likes. Uses Supabase RPC when configured; local-only fallback otherwise. */
  function initAdnanRatings(){
    var config = window.ADNAN_SHARED_LIKES || {};
    var supabaseUrl = String(config.url || '').replace(/\/+$/,'');
    var supabaseKey = String(config.key || '').trim();
    var sharedEnabled = !!(supabaseUrl && supabaseKey);

    function safeStorageGet(key){
      try { return window.localStorage.getItem(key); } catch(e) { return null; }
    }
    function safeStorageSet(key,value){
      try { window.localStorage.setItem(key,String(value)); return true; } catch(e) { return false; }
    }
    function visitorId(){
      var id = safeStorageGet('adnan-shared-like-visitor-v1');
      if(id && /^[0-9a-f-]{36}$/i.test(id)) return id;
      id = '';
      try { if(window.crypto && window.crypto.randomUUID) id = window.crypto.randomUUID(); } catch(e) {}
      if(!id) id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){
        var r=Math.random()*16|0; return (c==='x'?r:(r&3|8)).toString(16);
      });
      safeStorageSet('adnan-shared-like-visitor-v1',id);
      return id;
    }
    var visitor = visitorId();
    function rpc(name, body){
      if(!sharedEnabled) return Promise.reject(new Error('Shared likes are not configured'));
      return fetch(supabaseUrl + '/rest/v1/rpc/' + name, {
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json',
          'apikey':supabaseKey,
          'Authorization':'Bearer ' + supabaseKey
        },
        body:JSON.stringify(body)
      }).then(function(response){
        if(!response.ok) return response.text().then(function(message){throw new Error(message || 'Shared likes request failed');});
        return response.json();
      });
    }
    function getSharedCount(type,id){
      return rpc('get_adnan_like_count',{p_entity_type:type,p_entity_id:String(id)}).then(function(value){
        if(Array.isArray(value)) value=value.length ? value[0] : 0;
        if(value && typeof value==='object' && value.like_count!==undefined) value=value.like_count;
        var count=Number(value);
        if(!Number.isFinite(count) || count<0) throw new Error('Invalid shared like count');
        return count;
      });
    }
    function addSharedLike(type,id){
      return rpc('add_adnan_like',{p_entity_type:type,p_entity_id:String(id),p_visitor_id:visitor}).then(function(value){
        if(Array.isArray(value)) value=value.length ? value[0] : {};
        if(typeof value==='string'){try{value=JSON.parse(value);}catch(e){}}
        return getSharedCount(type,id).then(function(count){
          return {count:count, liked:!!(value && value.liked)};
        });
      });
    }
    function setupLike(button, countNode, type, id, localLikedKey, localCountKey, baseCount){
      var liked = safeStorageGet(localLikedKey)==='1';
      var count = Number(safeStorageGet(localCountKey));
      if(!Number.isFinite(count) || count<baseCount) count=baseCount;
      var busy=false;
      function render(){
        if(countNode) countNode.textContent=String(count);
        button.classList.toggle('is-liked',liked);
        button.setAttribute('aria-pressed',liked?'true':'false');
        button.setAttribute('aria-label',liked ? 'You liked this ' + (type==='store'?'store':'product') : 'Like this ' + (type==='store'?'store':'product'));
        button.title=liked?'Already liked — one like per browser':'Like once';
        button.setAttribute('aria-disabled',liked?'true':'false');
        /* Keep a liked button clickable only to show the locked/shake feedback; never reverse the vote. */
        button.disabled=busy;
      }
      function refresh(){
        if(!sharedEnabled) return;
        getSharedCount(type,id).then(function(n){
          count=n;
          safeStorageSet(localCountKey,count);
          if(!liked) render();
          else if(countNode) countNode.textContent=String(count);
        }).catch(function(){});
      }
      button.addEventListener('click',function(){
        if(liked){
          button.classList.remove('adnan-like-locked-shake');
          void button.offsetWidth;
          button.classList.add('adnan-like-locked-shake');
          window.setTimeout(function(){button.classList.remove('adnan-like-locked-shake');},480);
          return;
        }
        if(busy) return;
        busy=true; render();
        if(sharedEnabled){
          addSharedLike(type,id).then(function(result){
            liked=true; count=result.count;
            safeStorageSet(localLikedKey,'1'); safeStorageSet(localCountKey,count);
          }).catch(function(){
            /* Do not silently create a local-only vote when shared mode was configured but failed. */
            button.title='Could not save like. Please try again.';
          }).finally(function(){busy=false;render();});
        } else {
          liked=true; count+=1;
          safeStorageSet(localLikedKey,'1'); safeStorageSet(localCountKey,count);
          busy=false; render();
        }
      });
      render();
      refresh();
      if(sharedEnabled) window.setInterval(refresh,20000);
    }

    var store = document.querySelector('[data-adnan-store-rating]');
    if(store){
      var storeLike=store.querySelector('[data-store-like]');
      var storeCount=store.querySelector('[data-store-like-count]');
      /* Persistent shared ID: keep unchanged in future theme versions to preserve the same store-like count. */
      if(storeLike) setupLike(storeLike,storeCount,'store','adnan-mobile-shop-v40-final','adnan-store-liked-v40-final','adnan-store-like-count-v40-final',0);
    }
    Array.prototype.slice.call(document.querySelectorAll('[data-adnan-like]')).forEach(function(btn){
      var productId=String(btn.getAttribute('data-product-id')||'');
      if(!productId) return;
      var countNode=btn.querySelector('[data-like-count]');
      var base=Number(btn.getAttribute('data-base-likes')||0);
      if(!Number.isFinite(base)||base<0) base=0;
      /* Persistent per-product IDs: keep this namespace unchanged in future theme versions. */
      setupLike(btn,countNode,'product','adnan-mobile-shop-v40-final-'+productId,'adnan-product-liked-v40-final-'+productId,'adnan-product-like-count-v40-final-'+productId,0);
    });
  }

  function init(){
    initAdnanCartSelection();
    initAdnanRatings();
    initCategories();
    initProductGallery();
    initOutOfStockButtons();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();

